import ComponentDrawerRouterView from "./ComponentDrawerRouterView.vue";
import NewChildComponentDrawerRouterView from "./new-child-component/NewChildComponentDrawerRouterView.vue";
import ViewComponentDrawerRouterView from "./view/ViewComponentDrawerRouterView.vue";
export const extensionsComponentDrawerRouteConfig = {
    exitRouteName: "extension-detail",
    viewComponentRouteName: "extensions-view-component",
    newSocketChildComponentRouteName: "extensions-new-socket-child-component",
    newChildComponentRouteName: "extensions-new-child-component",
    topLevelComponentIdParameterName: "extensionComponentId",
};
export const campaignEditAudienceTabComponentDrawerRouteConfig = {
    exitRouteName: "campaign-edit-audience-tab",
    viewComponentRouteName: "campaign-edit-audience-tab-view-component",
    newSocketChildComponentRouteName: "campaign-edit-audience-tab-new-socket-child-component",
    newChildComponentRouteName: "campaign-edit-audience-tab-new-child-component",
};
export const labsFlowPageComponentDrawerRouteConfig = {
    exitRouteName: "labs-campaign-flow",
    viewComponentRouteName: "labs-campaign-flow-view-component",
    newSocketChildComponentRouteName: "labs-campaign-flow-new-socket-child-component",
    newChildComponentRouteName: "labs-campaign-flow-new-child-component",
};
export const labsComponentBuilderComponentDrawerRouteConfig = {
    exitRouteName: "labs-component-detail",
    viewComponentRouteName: "labs-component-builder-view-component",
    newSocketChildComponentRouteName: "labs-component-builder-new-socket-child-component",
    newChildComponentRouteName: "labs-component-builder-new-child-component",
    topLevelComponentIdParameterName: "componentId",
};
export const labsComponentBuilderComponentDrawerRouteConfigV2 = {
    exitRouteName: "component-builder",
    viewComponentRouteName: "component-builder-view-component",
    newSocketChildComponentRouteName: "component-builder-new-socket-child-component",
    newChildComponentRouteName: "component-builder-new-child-component",
    includeRootInBreadcrumbs: true,
};
export const campaignEditFlowComponentDrawerRouterConfig = {
    exitRouteName: "campaign-flow",
    viewComponentRouteName: "campaign-flow-view-component",
    newChildComponentRouteName: "campaign-flow-new-child-component",
    newSocketChildComponentRouteName: "campaign-flow-new-socket-child-component",
};
export const campaignDetailsPromotionComponentDrawerRouteConfig = {
    exitRouteName: "campaign-details-promotion-buttons",
    viewComponentRouteName: "campaign-details-promotion-buttons-view-component",
    newSocketChildComponentRouteName: "campaign-details-promotion-buttons-new-socket-child-component",
    newChildComponentRouteName: "campaign-details-promotion-buttons-new-child-component",
};
export const campaignEditOverviewTabComponentDrawerRouteConfig = {
    exitRouteName: "campaign-edit-overview-tab",
    viewComponentRouteName: "campaign-edit-overview-tab-view-component",
    newSocketChildComponentRouteName: "campaign-edit-overview-tab-new-socket-child-component",
    newChildComponentRouteName: "campaign-edit-overview-tab-new-child-component",
};
export const createComponentDrawerRoutes = (config) => {
    const output = [
        {
            path: ":componentDrawerComponentId",
            component: ComponentDrawerRouterView,
            props: (route) => {
                return Object.assign(Object.assign({}, route.params), { componentDrawerRouteConfig: config });
            },
            children: [
                {
                    path: "",
                    name: config.viewComponentRouteName,
                    component: ViewComponentDrawerRouterView,
                    props: (route) => {
                        return Object.assign(Object.assign({}, route.params), { componentDrawerRouteConfig: config });
                    },
                },
                {
                    path: ":componentDrawerSettingName/new",
                    name: config.newSocketChildComponentRouteName,
                    component: NewChildComponentDrawerRouterView,
                    props: (route) => {
                        const componentDrawerComponentId = String(route.params.componentDrawerComponentId);
                        const componentDrawerSettingName = String(route.params.componentDrawerSettingName);
                        let selectedComponentId;
                        if (typeof route.query.selectedComponentId === "string") {
                            selectedComponentId =
                                route.query.selectedComponentId;
                        }
                        let sequence;
                        if (typeof route.query.sequence === "string") {
                            sequence = route.query.sequence;
                        }
                        return {
                            componentDrawerComponentId,
                            componentDrawerSettingName,
                            selectedComponentId,
                            componentDrawerRouteConfig: config,
                            sequence,
                        };
                    },
                },
                {
                    path: "new",
                    name: config.newChildComponentRouteName,
                    component: NewChildComponentDrawerRouterView,
                    props: (route) => {
                        const componentDrawerComponentId = String(route.params.componentDrawerComponentId);
                        let selectedComponentId;
                        if (typeof route.query.selectedComponentId === "string") {
                            selectedComponentId =
                                route.query.selectedComponentId;
                        }
                        const deprecatedHavingAllTypes = [];
                        if (typeof route.query.deprecatedHavingAllTypes ===
                            "string") {
                            deprecatedHavingAllTypes.push(route.query.deprecatedHavingAllTypes);
                        }
                        else if (Array.isArray(route.query.deprecatedHavingAllTypes)) {
                            route.query.deprecatedHavingAllTypes.forEach((type) => {
                                if (typeof type === "string") {
                                    deprecatedHavingAllTypes.push(type);
                                }
                            });
                        }
                        return {
                            componentDrawerComponentId,
                            selectedComponentId,
                            componentDrawerRouteConfig: config,
                            deprecatedHavingAllTypes,
                        };
                    },
                },
            ],
        },
    ];
    return output;
};
export const navigateToExitComponentDrawerRoute = (componentDrawerRouteConfig, router) => {
    const currentRouteParameters = router.currentRoute.value.params;
    const currentQuery = router.currentRoute.value.query;
    router.push({
        name: componentDrawerRouteConfig.exitRouteName,
        params: currentRouteParameters,
        query: currentQuery,
    });
};
export const navigateToViewComponentDrawerRoute = (componentDrawerComponentId, componentDrawerRouteConfig, router) => {
    const currentRouteParameters = router.currentRoute.value.params;
    const currentQuery = router.currentRoute.value.query;
    const nextRouteParameters = Object.assign(Object.assign({}, currentRouteParameters), { componentDrawerComponentId });
    router.push({
        name: componentDrawerRouteConfig.viewComponentRouteName,
        params: nextRouteParameters,
        query: currentQuery,
    });
};
export const navigateToNewSocketChildComponentDrawerRoute = (componentDrawerComponentId, componentDrawerSettingName, componentDrawerRouteConfig, router, sequence) => {
    const currentRouteParameters = router.currentRoute.value.params;
    const currentQuery = router.currentRoute.value.query;
    const nextRouteParameters = Object.assign(Object.assign({}, currentRouteParameters), { componentDrawerComponentId, componentDrawerSettingName });
    const query = Object.assign(Object.assign({}, currentQuery), { sequence });
    router.push({
        name: componentDrawerRouteConfig.newSocketChildComponentRouteName,
        params: nextRouteParameters,
        query,
    });
};
export const navigateToNewChildComponentDrawerRoute = (componentDrawerComponentId, componentDrawerRouteConfig, router, deprecatedHavingAllTypes) => {
    const currentRouteParameters = router.currentRoute.value.params;
    const currentQuery = router.currentRoute.value.query;
    const nextRouteParameters = Object.assign(Object.assign({}, currentRouteParameters), { componentDrawerComponentId });
    const query = Object.assign(Object.assign({}, currentQuery), { deprecatedHavingAllTypes });
    router.push({
        name: componentDrawerRouteConfig.newChildComponentRouteName,
        params: nextRouteParameters,
        query,
    });
};
